module.exports = __webpack_public_path__ + "static/in-defense-of-food-6e7ae9ee824d1b643e823e3441e124f9.webp";